import Joi from 'joi'
import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { joiResolver } from '@hookform/resolvers/joi'

import Btn from '../../../../../../UI/Btn'
import TextField from '../../../../../../UI/TextField'

import SettingHint from '../SettingHint'
import TemplateLinks from '../TemplateLinks'

import styles from '../style.module.scss'

// Nur ein Feld: Die zweite Erinnerung (nach Einreichung ohne Freigabe) ist im
// Backend nicht umgesetzt (auskommentiert), deshalb hier auch nicht als Pflichtfeld
// gefordert - sonst ließe sich die Einstellung nicht speichern.
const schema = Joi.object({
	companyReminders: Joi.object().keys({
		firstReminderNotFinished: Joi.number().integer().min(1).required()
	})
})

export default function CompanyReminders(props) {
	const { t } = useTranslation()
	const {
		register,
		reset,
		handleSubmit,
		formState: { errors }
	} = useForm({
		resolver: joiResolver(schema)
	})

	const onSubmit = form => {
		props
			.updateOptions({ name: 'companyReminders', value: form.companyReminders })
			.then(() => toast.success(t('Options was updated')))
	}

	useEffect(() => {
		reset({ companyReminders: props.form?.companyReminders || {} })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.form])
	return (
		<form id="companyReminders" className={styles.root} onSubmit={handleSubmit(onSubmit)}>
			<section className={styles.section}>
				<h3 className={styles.sectionTitle}>{t('Company Reminders')}</h3>
				<SettingHint
					example={`Beispiel: Erinnerung 7 Tage nach Beginn der Firmenanlage, wenn sie noch nicht abgeschlossen ist.`}
					warning={`Der Erinnerungs-Lauf findet einmal täglich in der Nacht statt. Jede betroffene Firma wird nur einmal erinnert, nicht wiederholt. Fehlt hier ein Wert, wird der Lauf übersprungen und es gehen keine Erinnerungen raus.`}
				>
					{`Frist für die Erinnerung an Junior Companies, die ihre Firmenanlage nach dem Start nicht abgeschlossen und sich nicht angemeldet haben. Angabe in Tagen.`}
				</SettingHint>
				<TemplateLinks
					items={[
						{ channel: 'email', key: 'REMIND_ACTIVATE_COMPANY' },
						{ channel: 'internal', key: 'ACTIVATE_COMPANY_REMINDER' }
					]}
				/>
				<div className={styles.sectionContent}>
					<div className={styles.flexContainer}>
						<TextField
							className={styles.field}
							label={t(
								'1st reminder [x] days after company set-up started and not finished and no login'
							)}
							mb={20}
							register={register(`companyReminders.firstReminderNotFinished`)}
							error={errors.companyReminders?.firstReminderNotFinished}
						/>
					</div>
					{/* 					<div className={styles.flexContainer}>
						<TextField
							className={styles.field}
							label={t('1st reminder [x] days after company profile has been submitted for approval and no login')}
							mb={20}
							register={register(`companyReminders.firstReminderSubmittedApproval`)}
							error={errors.companyReminders?.firstReminderSubmittedApproval}
						/>
					</div> */}
					<div className={styles.btnContainer}>
						<Btn
							className={styles.btn}
							type="submit"
							icon="arrow"
							iconSize={{ w: 10, h: 10 }}
							iconColor="#fff"
						>
							{t('save')}
						</Btn>
					</div>
				</div>
			</section>
		</form>
	)
}

CompanyReminders.propTypes = {
	form: PropTypes.object.isRequired,
	updateOptions: PropTypes.func.isRequired
}
